import clsx from 'clsx';
import React, { useState } from 'react';

import { SecondaryButton } from '@components/Button/variants';
import { TextButton } from '@components/Button/variants';
import IconArrowDown from '@components/Images/Rebranding/IconArrowDown';
import { OpenPositionProps } from '@utils/aboutInterfaces';

const OpenPositions = ({ jobs }: OpenPositionProps) => {
  const [isActive, setActive] = useState(false);
  return (
    <div className="mt-24 border-0 border-b border-t border-solid border-grayscale-beige py-48">
      <TextButton
        as="button"
        className="flex	w-full items-center justify-between text-grayscale-charcoal no-underline hover:!text-grayscale-charcoal focus:text-grayscale-charcoal"
        onClick={() => setActive(!isActive)}
      >
        <h3 className="font-suisse-intl-mono text-caption-lg">Open positions</h3>
        <IconArrowDown
          className={clsx(
            'w-[26px] -rotate-90 transform fill-primary-magenta transition-transform md:mr-[102px]',
            {
              'rotate-0': isActive,
            }
          )}
        />
      </TextButton>

      {isActive && (
        <div className="mt-32 flex justify-end md:mr-[93px]">
          <table className="w-full border-separate border-spacing-y-24 sm:ml-32 md:ml-[83px]">
            <thead>
              <tr>
                <th className="border-0 border-b border-solid border-grayscale-beige px-28 pb-8 text-left font-suisse-intl-mono text-overline-sm text-primary-magenta">
                  Job title
                </th>
                <th className="hidden border-0 border-b border-solid border-grayscale-beige px-28 pb-8 text-left font-suisse-intl-mono text-overline-sm text-primary-magenta sm:block">
                  Location
                </th>
                <th className="border-0 border-b border-solid border-grayscale-beige px-28 pb-8 text-left font-suisse-intl-mono text-overline-sm text-primary-magenta">
                  Team
                </th>
                <th className="border-0 border-b border-solid border-grayscale-beige"></th>
              </tr>
            </thead>
            {jobs.map((job) => (
              <tbody key={job.jobTitle}>
                <tr>
                  <td className="w-auto border-0 border-l border-solid border-grayscale-charcoal px-28 py-8 text-left font-suisse-neue text-body-sm sm:max-w-[250px] sm:text-body-md">
                    {job.jobTitle}
                  </td>
                  <td className="hidden w-auto px-28 py-8 text-left font-suisse-neue text-body-sm sm:table-cell sm:max-w-[250px]">
                    {job.location}
                  </td>
                  <td className="w-auto px-28 py-8 text-left font-suisse-neue text-body-sm sm:max-w-[100px] ">
                    {job.department}
                  </td>
                  <td
                    className="border-0 border-r border-solid border-grayscale-charcoal px-24 py-8"
                    align="right"
                  >
                    <div className="flex w-[68px] justify-end sm:w-auto">
                      <SecondaryButton
                        as="link"
                        href={job.link}
                        className="px-16 py-8 !font-suisse-intl !text-button-sm sm:px-24 sm:!text-button-sm"
                      >
                        Apply
                      </SecondaryButton>
                    </div>
                  </td>
                </tr>
              </tbody>
            ))}
          </table>
        </div>
      )}
    </div>
  );
};

export default OpenPositions;
